jQuery(function ($) {
  // const urlParams = new URLSearchParams(window.location.search);
  // const devParam = urlParams.get('dev');
  // console.log(devParam);
  // if(devParam){
  //   $('#newsletter-popup .new-d').removeClass('d-none');
  // }

  setTimeout(() => {
    $('body').find('.yotpo-display-wrapper .yotpo-icon').attr('aria-hidden', true);
  }, 1000);

  var iframe = $("#certified-video");
  if (iframe[0]) {
    var player = new Vimeo.Player(iframe[0]);
    player.on("ended", function () {
      $("#takeQuiz").fadeIn();
      $("#rewatchVideo").fadeIn();
      $("#takeQuiz").focus();
    });
    player.on("play", function () {
      $("#takeQuiz").fadeOut();
      $("#rewatchVideo").fadeOut();
    });
    $("#rewatchVideo").on("click", function () {
      player.play();
    });
  }
  $("#takeQuiz").on("click", function () {
    $("#step-1").hide();
    $("#step-2").show();
    $("#step-2-title").focus();
  });
  $("#step-2").on("click", ".answer-button", function () {
    var answer = $(this).data("answer");
    if (answer) {
      var parent = $(this).parents(".certification-quiz__questions");
      var index = parent.data("index");
      // var total = parent.data('total');
      $(this).addClass("answer-is-correct").append('<span class="sr-only sr-only-focusable">Correct Answer</span>');
      if (index >= 1) {
        parent.find(".quiz__questions__item__btn-next").removeAttr("disabled");
      }
      return;
    }
    $(this).addClass("answer-is-wrong").append('<span class="sr-only sr-only-focusable">Wrong Answer</span>');;
  });
  $(".quiz__questions__item__btn-next").on("click", function () {
    var parent = $(this).parents(".certification-quiz__questions");
    var total = parent.data("total");
    var next = $(this).data("next");

    if (next <= total) {
      $("#step-2 .certification-quiz__questions").hide();
      $("#q-" + next).show();
    }
    if (next > total) {
      $("#step-2").hide();
      $("#spinner-loading").show();
      Accentuate($("#metafields_certification_form"), function (data) {
        // console.log(data);
        // console.log(data.status, data.message);
        if (data.status == "OK") {
          $("#spinner-loading").hide();
          $("#step-3").show();
          $("#step-3-title").focus();
        }
      });
    }
  });
  $(".quiz__questions__item__btn-prev").on("click", function () {
    var prev = $(this).data("prev");
    if (prev >= 1) {
      $("#step-2 .certification-quiz__questions").hide();
      $("#q-" + prev).show();
    }
  });
  
  $("#generate-pdf").on("click", function (e) {
    e.preventDefault();
    var name = $(this).data('name');
    var slug = $(this).data('slug');
    var pdf = $(this).attr('href');
    var nameCount = name.length;
    modifyPdf(name, nameCount, slug, pdf);
  });

  // Download
  // var download = $(".sbi-download").appendTo("body");
  // download[0].click();
  // download.remove();
  var tabs = new Tabs();

  $("#distrubutor__state-dropdown").on("change", function () {
    var selectRegion = $(this).val();
    $("#single-distributor-cont .single-distributor-col").each(function (
      index
    ) {
      if (selectRegion) {
        var all = $(this).data("all");
        if (all) {
          $(this).fadeIn();
          return;
        }
        var regions = $(this).data("region").split(",");
        if (regions) {
          var inArrayElm = $.inArray(selectRegion, regions);
          if (inArrayElm >= 0) {
            $(this).fadeIn();
            return;
          }
        }
        $(this).fadeOut();
      } else {
        $(this).fadeIn();
      }
    });
  });

  $(".serie-link-to").on("click", function (e) {
    var elem = $(this).attr("href");
    $("html,body").animate(
      {
        scrollTop: $(elem).offset().top,
      },
      700
    );
  });

  $(".sbi-download").on("click", function (e) {
    e.preventDefault();
    var imgSrc = $(this).attr("href");
    var imgName = $(this).attr("download");
    downloadImage(imgSrc, imgName);
  });

  async function downloadImage(imgSrc, imgName) {
    const image = await fetch(imgSrc);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);

    const link = document.createElement("a");
    link.href = imageURL;
    link.download = imgName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  $(".sbi-video-banner").on("click", ".video_play", function () {
    var video_id = $(this).data("video");
    $("#video_play-" + video_id).fadeOut();
    $("#video_stop-" + video_id).fadeIn();
    $("#video-" + video_id)
      .get(0)
      .play();
  });

  $(".sbi-video-banner").on("click", ".video_stop", function () {
    var video_id = $(this).data("video");
    $("#video_stop-" + video_id).fadeOut();
    $("#video_play-" + video_id).fadeIn();
    $("#video-" + video_id)
      .get(0)
      .pause();
  });

  // Init Product Slider
  $(".sbi-product-list-slider").slick();

  $(".ysc-bottom-header-links-slider").slick({
    dots: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });

  $('#stylist-type-ul').on('click', 'a', function(e){
    e.preventDefault();
    var stype = $(this).data('stype');
    $('#stylist-type-ul a').removeClass('active');
    $(this).addClass('active');
    $('#subscriber_type').val(stype);
    $('#subscriber_type_text').val(stype);
  })

  if (
    $("#newsletter-popup").data("show_popup") &&
    !$("#newsletter-popup").data("design_mode") &&
    !$("#newsletter-popup").data("alread_subcribe")
  ) {
    var popupnewsletter = readCookie("popupnewsletter");
    var myLity=null;
    // var popupnewsletterCount = readCookie("popupnewsletterCount");
    if (!popupnewsletter) {
      setTimeout(() => {
        myLity = lity("#newsletter-popup");
      }, 5000);
    }
  }

  $("body").on('focusout', '#newsletter-popup .sbi-close', function () {
    myLity.close();
    // $(this).trigger('click');
  });

  // PDF LIB 
  const { degrees, PDFDocument, rgb, StandardFonts } = PDFLib
  async function modifyPdf(name, nameCount, slug, pdf) {
    // Fetch an existing PDF document
    const pdf_name = slug + '.pdf';
    const url = pdf;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
  
    // Load a PDFDocument from the existing PDF bytes
    const pdfDoc = await PDFDocument.load(existingPdfBytes)
  
    // Embed the Helvetica font
    // const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
  
    // Get the first page of the document
    const pages = pdfDoc.getPages()
    const firstPage = pages[0]
  
    // Get the width and height of the first page
    const { width, height } = firstPage.getSize()
  
    // Draw a string of text diagonally across the first page
    firstPage.drawText(name, {
      x: (width - nameCount*10) / 2,
      y: height / 2 - 40,
      size: 20,
      // font: helveticaFont,
      // color: rgb(0.95, 0.1, 0.1),
      // rotate: degrees(-45),
    })
  
    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save()
  
    // Trigger the browser to download the PDF document
    // window.open(, '_blank');
    download(pdfBytes, pdf_name, "application/pdf");
  }

  // Calculate
  $('#sbi-calculator-form, #sbi-event-calculator-form').on('input', 'input', function(e){
    var value = $(this).val();
    var has_percent = $(this).data('has_percent');
    var elem_id = $(this).attr('id');
    if(has_percent){
      if(value > 100){
        value = 100;
      }
        if($('#range-value-'+elem_id).length){
          $('#range-value-'+elem_id).val(value);
        }
        $(this).val(value);
    }
  });

  $('#sbi-calculator-form, #sbi-event-calculator-form').on('input', 'input[type="range"]', function(e){
    var value = $(this).val();
    var input_id = $(this).data('range_id');
    $('#'+input_id).val(value);
  })

  $('#sbi-calculator-form').on('submit', function(e){
    e.preventDefault();
    var calFunction = $('#calculator-function').val();
    var values = $('#submit-values').data('inputs').split(',');
    var accentuate_result = $('#calculator_result').val();
    var accentuate_form = $("#metafields_calculator_form").length;
    // console.log(values);
    values.forEach(id => {
      var inputVal = $('#'+ id).val();
      calFunction = calFunction.replace(id, inputVal);
    });
    var result = eval(calFunction).toFixed(2);
    if(result){
      $("#spinner-loading").show();
      if(!accentuate_result && accentuate_form > 0){
        $('#calculator_result').val(result);
        $("#metafields_calculator_form").submit();
      }else{
        $("#spinner-loading").hide();
        $('#result-value').text(numberWithCommas(result));
        $('#calculator-result-cont').fadeIn();
      }
    }
  })

  $('#sbi-event-calculator-form').on('submit', function(e){
    e.preventDefault();
    var calFunction = $('#calculator-function').val();
    var values = $('#submit-values').data('inputs').split(',');
    // console.log(values);
    values.forEach(id => {
      var inputVal = $('#'+ id).val();
      calFunction = calFunction.replace(id, inputVal);
    });
    var result = eval(calFunction).toFixed(2);
    $("#spinner-loading").show();
    if(result){
        $("#spinner-loading").hide();
        $('#reset-calculator-cont').fadeIn();
        $('#result-value').text(numberWithCommas(result));
        $('#calculator-result-cont').fadeIn();
    }
  })

  Accentuate($("#metafields_calculator_form"), function (data) {
    // console.log(data);
    // console.log(data.status, data.message);
    if (data.status == "OK") {
      var result = $('#calculator_result').val();
      $("#spinner-loading").hide();
      $('#result-value').text(numberWithCommas(result));
      $('#calculator-result-cont').fadeIn();
    }
  });

  Accentuate($("#metafields_calculator_newsletter_form"), function (data) {
    if (data.status == "OK") {
      $('#metafields_calculator_newsletter_form').fadeOut();
    }
  });

  $('#send-calculator-user').on('click', function(){
    var email = $(this).data('email');
    var newsleter = $(this).data('newsletter');
    var tag = $(this).data('tag');
    var revenue = $('#result-value').text();
    if(email){
      $('#storeify_form_action_9894').find('input[name="send_to"]').val(email);
      $('#storeify_form_action_9894').find('.storeify-calculator-email').val(email);
      $('#storeify_form_action_9894').find('.storeify-calculator-tag').val(tag);
      $('#storeify_form_action_9894').find('.storeify-calculator-revenue').val(revenue);
      $('#storeify_form_action_9894').submit();
      if(!newsleter){
        $("#metafields_calculator_newsletter_form").submit();
      }
      $(this).fadeOut();
      $('#storeify-formbuilder-view-9894').fadeIn();
    }
  })

  Accentuate($("#metafields_event_calculator_newsletter_form"), function (data) {
    if (data.status == "OK") {
      $('#metafields_event_calculator_newsletter_form').fadeOut();

      send_event_email();
    }else{
      // console.log(data);
      if(data.message == "email: already has an account"){
        send_event_email();
      }else{
        if(data.errors.email){
          var error_text = 'Email '+ data.errors.email[0];
        }
        $('#email-label-error').text(error_text);
      }
    }
  });

  $('#send-event-calculator-user').on('click', function(){
    var email = $("#event-calculator-email").val();
    var newsleter = $("#event-calculator-marketing").prop("checked");
    if(validateEmail(email)){
      if(newsleter){
        $("#metafields_event_calculator_newsletter_form").submit();
      }else{
        send_event_email();
      }
    }else{
      $('#email-label-error').text('Email is invalid');
    }
  })

  function validateEmail($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test( $email );
  }

  function send_event_email (){
    var email = $("#event-calculator-email").val();
    var revenue = $('#result-value').text();
    var thank_page = $('#send-event-calculator-user').data('thank_page');
    var countSetI = 0;

    $('#storeify_form_action_10878').find('input[name="send_to"]').val(email);
    $('#storeify_form_action_10878').find('.storeify-calculator-email').val(email);
    $('#storeify_form_action_10878').find('.storeify-calculator-revenue').val(revenue);
    // $('#storeify_form_action_10878').submit();
    $('#storeify_form_action_10878').find('button.storeify-submit-frm').trigger('click');

    $('#metafields_event_calculator_newsletter_form').fadeOut();
    $('#send-event-calculator-user').fadeOut();
    $('#storeify-formbuilder-view-10878').fadeIn();

    var checkExist = setInterval(function() {
      const existFlag = document.getElementsByClassName('storeify-mes-success').length > 0;
      if (existFlag) {
        clearInterval(checkExist);
        if(thank_page){
            var redirect_email = $('#event-calculator-email').val();
            window.location.replace(thank_page+"?email="+redirect_email);
          }else{
            $('#reset-calculator').fadeIn();
          }
        }
      if(countSetI > 50){
        clearInterval(checkExist);
      }
      countSetI++;
   }, 300);
  }

  // Old way to redirect Storeify
  // $(document).ajaxComplete(function(event, jqxhr, settings) {
  //   // if `settings.context.id` is equal to `FormId`, do stuff
  //   // console.log('event', event);
  //   // console.log('jqxhr', jqxhr);
  //   if (settings.data.includes('id=10878')) {
  //     var thank_page = $('#send-event-calculator-user').data('thank_page');
  //     if(thank_page){
  //       var redirect_email = $('#event-calculator-email').val();
  //       // window.location.replace(thank_page+"?email="+redirect_email);
  //     }else{
  //       $('#reset-calculator').fadeIn();
  //     }
  //   }
  // });

  $('#subscribe-header-popup').on('click', function(e){
    e.preventDefault();
    popupNewsletter(true);
  });

  // PopUp klaviyoForms
  window.addEventListener("klaviyoForms", function(e) { 
    // console.log(e.detail.type);
    if (e.detail.type == 'close') {
      popupNewsletter(true);
      myLity.close();
    }
    // if (e.detail.type == 'open') {
    //   setTimeout(() => {
    //     $('body').find('#rich-text-102027428').attr('tabindex', '1').focus();
    //   }, 100);
    // }
  });

  $('#RegisterForm-sale-code').on('keyup', function(e){
      var inputVal = $(this).val();
      if(inputVal){
        var newStr = "Professional, " + inputVal;
        $('#RegisterForm-pro-tags').val(newStr);
      }else{
        $('#RegisterForm-pro-tags').val('Professional');
      }
  })
});

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function popupNewsletter(subscribe) {
  var days = 3; //number of days until they must go through the subscribe checker again.
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = "; expires=" + date.toGMTString();
  if (subscribe) {
    var email = $('#popup-header-email').val();
    var type = $('#subscriber_type').val();
    // console.log(email);
    // console.log(type);
    if(email && type){
      // jQuery.ajax({
      //   type: "POST",
      //   url: "/contact#ContactHeader", // replace with your newsletter subscription URL
      //   data: {
      //     email: email,
      //     type: type
      //   },
      //   success: function(response) {
      //     console.log(response);
      //     // handle success
      //     document.cookie = "popupnewsletter=true;" + expires + "; path=/";
      //   },
      //   error: function(response) {
      //     console.log(response);
      //     // handle error
      //     if (response.status === 409) { // replace 409 with the status code that indicates the email is already subscribed
      //       alert("You are already subscribed to the newsletter."); // replace with your desired error message
      //     }
      //   }
      // });
      document.cookie = "popupnewsletter=true;" + expires + "; path=/";
      document.getElementById("ContactHeader").submit();
    }
    // Only For klaviyo-form-SALLsv
    document.cookie = "popupnewsletter=true;" + expires + "; path=/";
    // document.getElementById("ContactHeader").submit();
  }
  if(subscribe == false){
    document.cookie = "popupnewsletter=true;" + expires + "; path=/";
  }
  //  location.reload();
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function Tabs(args) {
  // Scope-safe constructors
  if (!(this instanceof Tabs)) {
    return new Tabs();
  }

  /**
   * Default component settings
   *
   * @param container {string} Classname for container of the entire component
   * @param trigger {string} Element that toggles content
   * @param content {string} Classname for the content
   */
  var defaults = {
    container: "[data-tab-component]",
    trigger: '[role="tab"]',
    content: '[role="tabpanel"]',
  };

  // If there are no settings overrides
  var settings = typeof args !== "undefined" ? args : defaults;

  /**
   * @function toggle()
   *
   * Handles the displaying/hiding of content
   *
   * @returns null
   */
  var toggle = function () {
    var parent = this.closest(settings.container),
      target = this.getAttribute("aria-controls"),
      content = document.getElementById(target),
      toggles = parent.querySelectorAll(settings.trigger),
      all_content = parent.querySelectorAll(settings.content);

    // Update visibility
    for (var i = 0, len = toggles.length; i < len; i++) {
      toggles[i].setAttribute("aria-selected", "false");
      all_content[i].setAttribute("aria-hidden", "true");
    }

    this.setAttribute("aria-selected", "true");
    content.setAttribute("aria-hidden", "false");
  };

  /**
   * @function bindEventListeners()
   *
   * Attach event listeners
   *
   * @returns null
   */
  var bindEventListeners = function () {
    var trigger = document.querySelectorAll(settings.trigger);

    //
    // TODO
    // Use event delgation to add event handlers
    //
    for (var i = 0, len = trigger.length; i < len; i++) {
      trigger[i].addEventListener("click", function (event) {
        toggle.call(this);
      });

      trigger[i].addEventListener("keydown", function (event) {
        if (event.which == 13) {
          toggle.call(this);
        }
      });
    }
  };

  return bindEventListeners();

}
// Convert HTML Content to PDF with Images
function Convert_HTML_To_PDF() {
  var elementHTML = document.getElementById('contentToPrint');

  html2canvas(elementHTML, {
    useCORS: true,
    scale: 2,
    quality: 10,
    onrendered: function(canvas) {
      var pdf = new jsPDF('l', 'pt', 'a4');

      var pageHeight = 3508;
      var pageWidth = 2480;
      for (var i = 0; i <= elementHTML.clientHeight / pageHeight; i++) {
        var srcImg = canvas;
        var sX = 0;
        var sY = pageHeight * i; // start 1 pageHeight down for every new page
        var sWidth = pageWidth;
        var sHeight = pageHeight;
        var dX = 0;
        var dY = 0;
        var dWidth = pageWidth;
        var dHeight = pageHeight;

        window.onePageCanvas = document.createElement("canvas");
        onePageCanvas.setAttribute('width', pageWidth);
        onePageCanvas.setAttribute('height', pageHeight);
        var ctx = onePageCanvas.getContext('2d');
        ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

        var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);
        var width = onePageCanvas.width;
        var height = onePageCanvas.clientHeight;

        if (i > 0) // if we're on anything other than the first page, add another page
          pdf.addPage(612, 864); // 8.5" x 12" in pts (inches*72)

        pdf.setPage(i + 1); // now we declare that we're working on that page
        pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width * .62), (height * .62)); // add content to the page
      }
			
	  // Save the PDF
      // pdf.save('document.pdf');
    }
  });
}
